import { render, staticRenderFns } from "./Developments.vue?vue&type=template&id=03f2fd98&scoped=true&"
import script from "./Developments.vue?vue&type=script&lang=js&"
export * from "./Developments.vue?vue&type=script&lang=js&"
import style0 from "./Developments.vue?vue&type=style&index=0&id=03f2fd98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f2fd98",
  null
  
)

export default component.exports